import clsx from 'clsx'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {HeaderNotificationsMenu, HeaderUserMenu, Search, ThemeModeSwitcher} from '../../../partials'
import {useLayout} from '../../core'
import {useAuth} from '../../../../app/modules/auth'

const itemClass = 'ms-1 ms-md-4'
const btnClass =
  'btn btn-icon btn-custom btn-icon-muted btn-active-light btn-active-color-primary w-35px h-35px'
const userAvatarClass = 'symbol-35px'
const btnIconClass = 'fs-2'

const Navbar = () => {
  const {config} = useLayout()
  const {currentUser} = useAuth()
  
  return (
    <div className='app-navbar flex-shrink-0 w-100 align-items-center'>
      {/* Saludo a la izquierda */}
      <div className={clsx('app-navbar-item', itemClass)} style={{marginLeft: 0}}>
        <div className='d-flex flex-column align-items-start'>
          <span className='text-gray-800 fs-2 fw-bold lh-1'>
            Hola, {currentUser?.first_name}!
          </span>
          <span className='text-muted fs-8 fw-semibold lh-1 mt-1'>
            {currentUser?.email}
          </span>
        </div>
      </div>

      {/* Espaciador flexible */}
      <div className='flex-grow-1'></div>

      {/* Elementos a la derecha */}
      <div className='d-flex align-items-center'>
        <div className={clsx('app-navbar-item ml-5', itemClass)}>
          <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
        </div>

        <div className={clsx('app-navbar-item ml-5', itemClass)}>
          <div
            className={clsx('cursor-pointer symbol', userAvatarClass)}
            data-kt-menu-trigger="{default: 'click'}"
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
          >
            <img src={toAbsoluteUrl('/media/avatars/blank.png')} alt='' />
          </div>
          <HeaderUserMenu />
        </div>

        {config.app?.header?.default?.menu?.display && (
          <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
            <div
              className='btn btn-icon btn-active-color-primary w-35px h-35px'
              id='kt_app_header_menu_toggle'
            >
              <KTIcon iconName='text-align-left' className={btnIconClass} />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export {Navbar}
